<template>
  <div class="owc-hotspot-simple-item">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <wb-tooltip-host
      class="owc-hotspot-simple-item__spot"
      open="true"
      :position="tooltipPosition"
      :style="{
        '--coordinate-x': `${item.coordinateX}%`,
        '--coordinate-y': `${item.coordinateY}%`,
      }"
    >
      <span class="owc-hotspot-simple-item__spot-dot"></span>
      <wb-tooltip class="owc-hotspot-simple-item__tooltip" hidden>
        {{ item.hotspotText }}
      </wb-tooltip>
    </wb-tooltip-host>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  HotspotSimpleAuthorItemComputed,
  HotspotSimpleAuthorItemProps,
} from '@owc-packages/Hotspot/src/HotspotSimpleItem.d';
import { calculateSimpleItemTooltipPosition } from '@owc-packages/Hotspot/src/HotspotUtils';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

export default Vue.extend<{}, {}, HotspotSimpleAuthorItemComputed, HotspotSimpleAuthorItemProps>({
  name: 'owc-hotspot-simple-author-item',
  components: {
    ValidationBoxWrapper,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tooltipPosition() {
      return calculateSimpleItemTooltipPosition(this.item);
    },
  },
});
</script>
<style lang="scss" scoped>
@import 'HotspotItem';

$moduleName: 'owc-hotspot-simple-item';

[dir='ltr'] .#{$moduleName} {
  @include hotspot-item($moduleName);

  &__spot {
    position: absolute;
    top: calc(var(--coordinate-y) - #{math.div($hotSpotSize, 2)});
    left: calc(var(--coordinate-x) - #{math.div($hotSpotSize, 2)});

    z-index: 2;

    pointer-events: none;
  }
}
</style>
